import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import threadInfoFragment from '../../fragments/thread/threadInfo';

import { getThreadByIdQuery } from '../../queries/thread/getThread';

export const addThreadReactionQuery = gql`
  mutation addThreadReaction($input: AddThreadReactionInput!) {
    addThreadReaction(input: $input) {
      ...threadInfo
    }
  }
  ${threadInfoFragment}
`;

const addThreadReactionOptions = {
  props: ({ ownProps, mutate }) => ({
    addThreadReaction: ({ input }) => {
      const fakeId = Math.round(Math.random() * -1000000);
      return mutate({
        variables: {
          input: {
            ...input,
            type: 'like',
          },
        },
        optimisticResponse: {
          __typename: 'Mutation',
          addThreadReaction: {
            id: fakeId,
            threadId: input.threadId,
            type: 'like',
            __typename: 'ThreadReaction',
          },
        },
        update: (store, { data: { addThreadReaction } }) => {
          const data = store.readQuery({
            query: getThreadByIdQuery,
            variables: {
              id: input.threadId,
            },
          });

          // ignore the server response and only update the cache with the
          // optimistic response
          if (typeof addThreadReaction.id === 'string') return;

          data.thread.reactions.count++;
          data.thread.reactions.hasReacted = true;

          // Write our data back to the cache.
          store.writeQuery({
            query: getThreadByIdQuery,
            data,
            variables: {
              id: input.threadId,
            },
          });
        },
      });
    },
  }),
};

export default graphql(addThreadReactionQuery, addThreadReactionOptions);
